export enum TonsilSize {
    onbekend = 'Onbekend',
    status_na_tonsillectomie = '0 Status na tonsillectomie of niet zichtbaar',
    tonsillen_binnen_de_farynxbogen = '1 Tonsillen binnen de farynxbogen',
    tonsillen_vergroot_tot_buiten_de_farynxbogen = '3 Tonsillen vergroot tot buiten de farynxbogen',
    tonsillen_vergroot_tot_de_farynxbogen = '2 Tonsillen vergroot tot de farynxbogen',
    tonsillen_vergroot_tot_de_mediaanlijn_kissing_tonsils = '4 Tonsillen vergroot tot de mediaanlijn, "kissing tonsils"',
}
